import { Component, OnInit, ViewChild } from "@angular/core";
import { NavController, NavParams, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EventoDetalhesPage } from "./evento-detalhes/evento-detalhes.page";
import { EventoProvider } from "src/app/services/evento/evento";
import { UserProvider } from "src/app/services/user/user";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule, Location } from "@angular/common";
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from "@angular/forms";
import { BackgroundImage } from "src/app/components/background-image/background-image";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { addDays, format, subDays } from "date-fns";
import { IonModal } from "@ionic/angular/common";
import { AlertController, ToastController } from "@ionic/angular/standalone";

@Component({
  selector: "app-evento",
  templateUrl: "./evento.page.html",
  styleUrls: ["./evento.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    DateFormatPipe,
    BackgroundImage,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
    ProverDatepickerComponent,
  ],
})
export class EventoPage implements OnInit {
  @ViewChild("modalFilter", { static: false }) modalFilter!: IonModal;
  form: FormGroup;
  eventoTipo: string;
  eventos: any[] = [];
  evento: any = {};
  eventosInscrito: any;
  tipoEvento: any;
  loaded = false;
  isEnsino = false;
  datas: any = [];
  mes: any = 0;
  currentUrl: boolean;
  dataInicio = format(subDays(new Date(), 10), "yyyy-MM-dd");
  dataFim = format(addDays(new Date(), 10), "yyyy-MM-dd");
  tiposEventos: any;
  tipoSelecionado = "0";
  searchTerm: string = "";
  eventosFiltrados: any[] = [];
  eventosInscFiltrados: any[] = [];
  categorias: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public eventoProvider: EventoProvider,
    public userProvider: UserProvider,
    public router: Router,
    private location: Location,
    public active: ActivatedRoute,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    public toastCtrl: ToastController,
    private formBuilder: FormBuilder
  ) {
    const locationUrl = this.location.path();
    this.currentUrl = locationUrl === "/tabs/EventoPage" ? true : false;

    this.eventoTipo = "programacao";
    this.tipoEvento = this.active.snapshot.paramMap.get("params")
      ? this.active.snapshot.paramMap.get("params")
      : this.navParams.get("params");
    this.isEnsino = this.tipoEvento === "2";
    this.categorias = this.navParams.get("categorias");
    this.buscarEvento();
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      dataInicio: new FormControl(this.dataInicio, Validators.nullValidator),
      dataFim: new FormControl(this.dataFim, Validators.nullValidator),
      tipoSelecionado: [this.categorias ? this.categorias : "0"],
    });

    this.eventosFiltrados = [];
    this.eventosInscFiltrados = [];
  }

  segmentChanged(event: any) {
    this.eventoTipo = event.detail.value;
    this.searchTerm = "";
    this.atualizarFiltrados();
  }

  async selecionarEvento(id: any) {
    const modalPage = await this.modalCtrl.create({
      component: EventoDetalhesPage,
      componentProps: { id: id, isEnsino: this.isEnsino },
    });
    modalPage.present();
  }

  buscarEvento() {
    this.eventoProvider.postEventosTipos({ tipoEvento: this.tipoEvento }).subscribe((data) => {
      this.tiposEventos = data;
    });

    const dados = {
      tipoEvento: this.tipoEvento,
      tipoSelecionado: this.categorias ? this.categorias : null,
    };

    this.eventoProvider.getEventosInscrito(dados).subscribe((data) => {
      this.eventosInscrito = data;
      this.eventosInscFiltrados = this.agruparEventosPorMes(data);
    });

    this.eventoProvider.getEventos(dados).subscribe((data) => {
      this.eventos = data;
      this.eventosFiltrados = [...this.eventos];
      this.eventos.forEach((datas: { eventos: any[]; data: any }) => {
        datas.eventos.forEach((evento: { dataInicio: any }) => {
          datas.data = evento.dataInicio;
        });
      });
    });

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  async filter() {
    const { dataInicio, dataFim, tipoSelecionado } = this.form.value;

    if (dataInicio && dataFim) {
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);

      if (fim < inicio) {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("A data final não pode ser menor que a data inicial."),
          duration: 3000,
        });
        toast.present();
        return;
      }
    }

    const dados = {
      tipoEvento: this.tipoEvento,
      dataInicio,
      dataFim,
      tipoSelecionado,
    };

    if (this.eventoTipo == "programacao") {
      this.eventos = [];
      this.eventoProvider.getEventos(dados).subscribe((data) => {
        this.eventos = data;
        this.eventosInscFiltrados = [...this.eventosInscrito];
        this.eventos.forEach((datas: { eventos: any[]; data: any }) => {
          datas.eventos.forEach((evento: { dataInicio: any }) => {
            datas.data = evento.dataInicio;
          });
        });
        this.atualizarFiltrados();
        this.modalFilter.dismiss();
      });
    } else {
      this.eventosInscrito = [];
      this.eventoProvider.getEventosInscrito(dados).subscribe((data) => {
        this.eventosInscrito = data;
        this.eventosInscFiltrados = this.agruparEventosPorMes(data);
      });
      this.atualizarFiltrados();
      this.modalFilter.dismiss();
    }
  }

  onInput(event: any) {
    this.searchTerm = event.detail.value?.toLowerCase() || "";
    this.atualizarFiltrados();
  }

  private atualizarFiltrados() {
    const termo = this.searchTerm?.toLowerCase() || "";

    if (this.eventoTipo === "programacao") {
      if (!termo) {
        this.eventosFiltrados = [...this.eventos];
      } else {
        this.eventosFiltrados = this.eventos
          .map((dia: any) => {
            const eventosFiltradosDia = dia.eventos.filter((evento: any) => evento.tema?.toLowerCase().includes(termo));
            if (eventosFiltradosDia.length > 0) {
              return { ...dia, eventos: eventosFiltradosDia };
            } else {
              return null;
            }
          })
          .filter(Boolean);
      }
    } else if (this.eventoTipo === "inscrito") {
      if (!termo) {
        this.eventosInscFiltrados = this.agruparEventosPorMes(this.eventosInscrito);
      } else {
        const filtrados = this.eventosInscrito.filter((ev: any) => ev.tema?.toLowerCase().includes(termo));

        this.eventosInscFiltrados = this.agruparEventosPorMes(filtrados);
      }
    }
  }

  async lerMais(descricao: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: "Solicitação",
      message: this.translate.instant(descricao),
      buttons: [
        {
          text: this.translate.instant("Fechar"),
          handler: () => {},
        },
      ],
    });
    alert.present();
  }

  getNomenclatura(tipoEvento: string) {
    return tipoEvento === "2" ? "ensinos" : "eventos";
  }

  agruparEventosPorMes(eventos: any[]) {
    const aux: any = {};

    eventos
      .sort((a, b) => new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime())
      .forEach((evento) => {
        if (!evento.dataInicio) {
          return;
        }

        const mesAno = evento.dataInicio.substring(0, 7);

        if (!aux[mesAno]) {
          aux[mesAno] = {
            data: mesAno,
            eventos: [],
          };
        }

        aux[mesAno].eventos.push(evento);
      });

    return Object.values(aux).sort((a: any, b: any) => b.data.localeCompare(a.data));
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
